import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import styles from "./LoginScreen.module.scss";
import { notifyError } from "../../utils/notify";

import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import Input from "../../components/Input/Input";
import { login } from "../../store/slices/auth/asyncThunks";
import { selectChoosenSchool } from "../../store/slices/school/slice";

import { isValidEmail } from "../../utils/util";

const LoginScreen = () => {
  const choosenSchool = useSelector(selectChoosenSchool);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const validateInputData = useMemo(() => {
    if (
      email.trim().length > 0 &&
      password.trim().length > 0 &&
      isValidEmail(email)
    ) {
      return true;
    } else {
      return false;
    }
  }, [email, password]);

  const makeLogin = () => {
    dispatch(login({ email, password })).then((promise) => {
      if (promise.payload) {
        if (location.state?.from) {
          navigate(location.state.from);
        } else {
          navigate("/");
        }
      } else {
        notifyError("Wrong email or password");
      }
    });
  };
  //   if not choosen school, go to login-school
  return choosenSchool?.name.trim().length > 0 ? (
    <div className={styles.loginScreenContainer}>
      <div className={styles.card}>
        <Card>
          <div className={styles.loginCardContainer}>
            <div>
              <h1>Welcome!</h1>
              <h2>Sign in</h2>
            </div>

            <Input
              placeholder="Email"
              onChange={(event) => setEmail(event)}
            ></Input>
            <Input
              placeholder="Password"
              type="password"
              onChange={(event) => setPassword(event)}
            ></Input>

            {/* <div className={styles.forgotPasswordContainer}>
              <Link
                className={styles.forgotPasswordContainerLink}
                to="/forgot-password"
              >
                Forgot password?
              </Link>
            </div> */}

            <div className={styles.buttonContainer}>
              <Button
                aria-label="Login"
                title="Sign In"
                disabled={!validateInputData}
                onClick={makeLogin}
              />
            </div>
          </div>
        </Card>
      </div>
      <div
        style={{
          fontSize: "1.8rem",
          lineHeight: "2.1rem",
          textAlign: "center",
        }}
      >
        <span style={{ textAlign: "center" }}>Don’t have an account?</span>
        <Link
          className={styles.forgotPasswordSpanLink}
          to="/registration"
          style={{ paddingLeft: "1rem", fontWeight: "bold" }}
        >
          Register
        </Link>
      </div>
      <h3>Powered by Aware Technology</h3>
    </div>
  ) : (
    <Navigate to="/login-school" />
  );
};

export default LoginScreen;
